import React, { useState, useEffect } from "react";
import {Button, createTheme, Grid, IconButton, InputBase, ThemeProvider, Typography} from '@material-ui/core';
import {useHistory} from 'react-router-dom';
import useStyles from '../../assets/styles';
import { hasUserPermission } from "src/app/permission";

export const JiraDetailsComponent = ({jiraBoard, jiraURL, email, apiToken, projectKey, handleInputChange, handleSubmit, handleRedirect, decreaseStep, increaseStep, nameError, urlError, emailError, tokenError, keyError, isprojectExist, projectDetail }) => {
    const theme = createTheme({
        typography: {
            fontFamily: "'Poppins', sans-serif",
        },
    });
    const classes = useStyles();
    return(
        <ThemeProvider theme={theme}>
            <div>
                <Grid container className={classes.root}>
                    <Grid item xs={12} md={12}>
                        <Grid container className={classes.formContent}>
                            <Grid container className={classes.dataStreamBoxContainer}>
                                <Grid
                                    item
                                    container
                                    xs={12}
                                    md={12}
                                    alignItems="flex-start"
                                    style={{ marginBottom: "20px" }}
                                >
                                    <Grid item xs={12} md={12}>
                                    <Typography className={classes.typo}>
                                        Jira Board Name <span style={{ color: "red" }}>*</span>
                                    </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <InputBase
                                        className={classes.formInput}
                                        type="text"
                                        placeholder="Enter jira borad name here"
                                        name="boardName"
                                        value={isprojectExist ? projectDetail.jiraBoard : jiraBoard}
                                        onChange={handleInputChange}
                                        disabled={isprojectExist}
                                        />
                                    </Grid>
                                    {nameError && (
                                    <Grid
                                        item
                                        container
                                        xs={12}
                                        md={12}
                                        justifyContent="flex-end"
                                        alignItems="center"
                                        style={{ padding: "0px 8px" }}
                                    >
                                        <Typography className={classes.errorText}>
                                        {nameError}
                                        </Typography>
                                    </Grid>
                                    )}
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={6}
                                        style={{ marginBottom: "20px" }}
                                    >
                                        <Grid item xs={12} md={12}>
                                        <Typography className={classes.typo}>
                                            Jira URL <span style={{ color: "red" }}>*</span>
                                        </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <InputBase
                                            className={classes.formInput}
                                            type="text"
                                            placeholder="Enter jira url here"
                                            name="url"
                                            value={isprojectExist ? projectDetail.jiraURL : jiraURL}
                                            onChange={handleInputChange}
                                            disabled={isprojectExist}
                                            />
                                        </Grid>
                                        {urlError && (
                                        <Grid
                                            item
                                            container
                                            xs={12}
                                            md={12}
                                            justifyContent="flex-end"
                                            alignItems="center"
                                            style={{ padding: "0px 8px" }}
                                        >
                                            <Typography className={classes.errorText}>
                                            {urlError}
                                            </Typography>
                                        </Grid>
                                        )}
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={6}
                                        style={{ marginBottom: "20px" }}
                                    >
                                        <Grid item xs={12} md={12}>
                                        <Typography className={classes.typo}>
                                            Reporter's Email
                                            <span style={{ color: 'red' }}>*</span>
                                        </Typography> 
                                        </Grid>                                      
                                        <Grid item xs={12} md={12}>
                                            <InputBase
                                            className={classes.formInput}
                                            type="text"
                                            placeholder="example@gmail.com"
                                            name="email"
                                            value={isprojectExist ? projectDetail.email : email}
                                            onChange={handleInputChange}
                                            disabled={isprojectExist}
                                            />
                                        </Grid>
                                        {emailError && (
                                        <Grid
                                            item
                                            container
                                            xs={12}
                                            md={12}
                                            justifyContent="flex-end"
                                            alignItems="center"
                                            style={{ padding: "0px 8px" }}
                                        >
                                            <Typography className={classes.errorText}>
                                            {emailError}
                                            </Typography>
                                        </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={6}
                                        style={{ marginBottom: "20px" }}
                                    >
                                        <Grid item container xs={12} md={12}>
                                            <Typography className={classes.typo}>
                                                API Token
                                                <span style={{ color: 'red' }}>*</span>
                                            </Typography>  
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <InputBase
                                            className={classes.formInput}
                                            type="text"
                                            placeholder="Enter API token here"
                                            name="apiToken"
                                            value={isprojectExist ? projectDetail.apiToken : apiToken}
                                            onChange={handleInputChange}
                                            disabled={isprojectExist}
                                            />
                                        </Grid>
                                        {tokenError && (
                                        <Grid
                                            item
                                            container
                                            xs={12}
                                            md={12}
                                            justifyContent="flex-end"
                                            alignItems="center"
                                            style={{ padding: "0px 8px" }}
                                        >
                                            <Typography className={classes.errorText}>
                                            {tokenError}
                                            </Typography>
                                        </Grid>
                                        )}
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={6}
                                        style={{ marginBottom: "20px" }}
                                    >
                                        <Grid item container xs={12} md={12}>
                                            <Typography className={classes.typo}>
                                                Project Key
                                                <span style={{ color: 'red' }}>*</span>
                                            </Typography>  
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <InputBase
                                            className={classes.formInput}
                                            type="text"
                                            placeholder="Enter project key here"
                                            name="projectKey"
                                            value={isprojectExist ? projectDetail.projectKey : projectKey}
                                            onChange={handleInputChange}
                                            disabled={isprojectExist}
                                            />
                                        </Grid>
                                        {keyError && (
                                        <Grid
                                            item
                                            container
                                            xs={12}
                                            md={12}
                                            justifyContent="flex-end"
                                            alignItems="center"
                                            style={{ padding: "0px 8px" }}
                                        >
                                            <Typography className={classes.errorText}>
                                            {keyError}
                                            </Typography>
                                        </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} style={{ marginTop: "5px" }} justifyContent="flex-end">
                                    <Grid item>
                                        <Button
                                        variant="contained"
                                        className={classes.backButton}
                                        style={{margin: "0px"}}
                                        onClick={decreaseStep}
                                        >
                                        Back
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                        variant="contained"
                                        className={`${classes.devicePulseSaveButton} ${classes.button}`}
                                        onClick={isprojectExist ? handleRedirect : increaseStep}
                                        disabled={isprojectExist && !hasUserPermission("SETUP_DEVICE_PULSE.ITSM_CONFIGURATION.JIRA", "EDIT")}>
                                            {isprojectExist ? "Edit" : "Next"}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>                                                         
            </div>
        </ThemeProvider>
    )
}